import { EventEmitter, Injectable, ViewContainerRef } from "@angular/core";
import { CpxCardInterface } from "src/app/utils/interfaces/new/cpx-card-interface";
import { CpxCardInfoStatus, CpxCardSignature, CpxCardStatusEnum, CpxSessionInterface } from "src/app/utils/interfaces/new/cpx-session.interface";
import { LectureCarteVitale, CheckVitaleStatus, VitaleInfos } from "src/app/utils/interfaces/new/lecture-carte-vitale";
import { CardRippedStatus, CpxHandleServiceAbstract, SessionTypeEnum, TypeConnecteurEnum, WirelessModeCardType } from "./cpx-handle-service-abstract";

@Injectable({
  providedIn: 'root'
})
export class CpxHandleMockService extends CpxHandleServiceAbstract {
  isWirelessMode(type: SessionTypeEnum): Promise<boolean> {
    throw new Error("Method not implemented.");
  }
  updateCpxAuthenticationToken(cardType: WirelessModeCardType, authToken: string): Promise<void> {
    throw new Error("Method not implemented.");
  }
  setInsiConnectorIsCreated(type: SessionTypeEnum, connecteur: TypeConnecteurEnum, isCreated?: boolean): void {
    throw new Error("Method not implemented.");
  }
  setDmpConnectorIsCreated(type: SessionTypeEnum, connecteur: TypeConnecteurEnum, isCreated?: boolean): void {
    throw new Error("Method not implemented.");
  }
  setPracticeSetting(practiceSetting: any): void {
    throw new Error("Method not implemented.");
  }
  isErrorEndSession(error: any, type: SessionTypeEnum): boolean {
    throw new Error("Method not implemented.");
  }
  getPracticeLocationActivity(): Promise<{ pinCode?: string; practiceLocationActivity: string; practiceSettingIndice?: number; }> {
    throw new Error("Method not implemented.");
  }
  closeSession(): Promise<void> {
    throw new Error("Method not implemented.");
  }
  getInstance(view: ViewContainerRef): Promise<any> {
    throw new Error("Method not implemented.");
  }
  showCpxModal(view: ViewContainerRef): Promise<{isSessionOpen: boolean}> {
    throw new Error("Method not implemented.");
  }
  isModalOpen(): boolean {
    return false;
  }
  isSessionOpen(): Promise<boolean> {
    throw new Error("Method not implemented.");
  }
  getInsFromVitale(view: ViewContainerRef, resourceId: string): Promise<any> {
    throw new Error("Method not implemented.");
  }
  getLastVitaleRead(): LectureCarteVitale | undefined {
    throw new Error("Method not implemented.");
  }
  getVitaleInfos(vitaleIndex: number): Promise<VitaleInfos | undefined> {
    throw new Error("Method not implemented.");
  }
  isSameVitaleCard(): Promise<boolean> {
    throw new Error("Method not implemented.");
  }
  selectPracticeSettingIndice(indice: number): void {
    throw new Error("Method not implemented.");
  }

  getCpxCardStatus(view: ViewContainerRef): Promise<CpxCardInfoStatus> {
    return new Promise<CpxCardInfoStatus>((resolve) => {
      const date = new Date();
      date.setFullYear(2999);
      resolve({
        i_cardStatus: 4,
        i_nbInputLeft: 3,
        s_cardId: "testCard",
        s_validityDate: date
      });
    });
  }

  checkVitaleStatus(view: ViewContainerRef): Promise<CheckVitaleStatus> {
    return new Promise<CheckVitaleStatus>((resolve) => {
      resolve({} as CheckVitaleStatus);
    });
  }


  signWithCpx(view: ViewContainerRef, data: string, pincode: string, authSign=false): Promise<CpxCardSignature> {
    return new Promise<CpxCardSignature>((resolve) => {
      resolve({
        s_signature: "",
        s_signatureCertificate: ""
      });
    });
  }

  lectureVitale(view: ViewContainerRef, slotName?: string): Promise<LectureCarteVitale> {
    return new Promise<LectureCarteVitale>((resolve) => {
      resolve({} as LectureCarteVitale);
    });
  }
  lectureCpxCard(slotName: string): Promise<CpxCardInterface> {
    return new Promise<CpxCardInterface>((resolve) => {
      resolve({} as CpxCardInterface);
    });
  }
  readCpx(slotName: string, pinCode: string): Promise<CpxSessionInterface> {
    return new Promise<CpxSessionInterface>((resolve) => {
      resolve({} as CpxSessionInterface);
    });
  }
  getCpxSession(view: ViewContainerRef): Promise<CpxSessionInterface> {
    return {} as Promise<CpxSessionInterface>;
  }
  getCpxCard(session: CpxSessionInterface): Promise<void> {
    return new Promise<void>((resolve) => {
      resolve();
    });
  }

  public cpxCardRipped = new EventEmitter<CardRippedStatus>();

  public getMockCase(): any {
    return this.mockVitaleCase;
  }

  public mockVitaleCase = [
    {
      Patients: [
        {
          i_birthRank: 1,
          i_quality: 0,
          id: 0,
          s_birthday: "15011990",
          s_birthname: "DUPONT",
          s_name: "DUPONT",
          s_given: "MARC",
          s_certifiedNir: "190014414500535",
          s_nir: "190014414500535",
          s_insC: "0111981550750305472189",
        },
        {
          i_birthRank: 2,
          i_quality: 0,
          s_birthday: "18121995",
          s_birthname: "AIRE",
          s_name: "AIRE",
          s_given: "AXEL",
          s_certifiedNir: "195124424501039",
          s_nir: "195124424501039",
          s_insC: "0972846792913992566602",
        }
      ],
      i_cardStatus: 3,
      s_cardStatusText: "Carte trouvée, il s'agit d'une carte réelle",
      s_status: "OK"
    },
    {
      Patients: [
        {
          i_birthRank: 4,
          i_quality: 1,
          id: 0,
          s_birthday: "28041952",
          s_birthname: "DURANT",
          s_name: "DURANT",
          s_given: "PIERRE",
          s_certifiedNir: "152040120300523",
          s_nir: "152040120300523",
          s_insC: "1101475069278951159446",
        }
      ],
      i_cardStatus: 4,
      s_cardStatusText: "Carte trouvée, il s'agit d'une carte de test",
      s_status: "OK"
    },
    {
      Patients: [
        {
          i_birthRank: 0,
          i_quality: 0,
          id: 0,
          s_birthday: "",
          s_birthname: "",
          s_name: "",
          s_given: "",
          s_certifiedNir: "",
          s_nir: "",
          s_insC: "",
        }
      ],
      i_cardStatus: 1,
      s_cardStatusText: "Carte absente",
      s_status: "OK"
    },
    {
      Patients: [
        {
          i_birthRank: 2,
          i_quality: 2,
          id: 0,
          s_birthday: "25041948",
          s_birthname: "GOGUEN",
          s_name: "GINGRAS",
          s_given: "BRIGITTE",
          s_certifiedNir: "248040651824892",
          s_nir: "248040651824892",
          s_insC: "1062452743960273281346",
        }
      ],
      i_cardStatus: 5,
      s_cardStatusText: "Carte trouvée, il s'agit d'une carte de démonstration",
      s_status: "OK"
    },
    {
      Patients: [
        {
          i_birthRank: 1,
          i_quality: 3,
          id: 0,
          s_birthday: "10041971",
          s_birthname: "SAUVE",
          s_name: "SAUVE",
          s_given: "OLIVIER",
          s_certifiedNir: "171041223533974",
          s_nir: "171041223533974",
          s_insC: "1649142348080886222343",
        }
      ],
      i_cardStatus: 1,
      s_cardStatusText: "Carte trouvée, il s'agit d'une carte réelle",
      s_status: "OK"
    },
    {
      Patients: [
        {
          i_birthRank: 1,
          i_quality: 4,
          id: 0,
          s_birthday: "24051966",
          s_birthname: "DESCHAMPS",
          s_name: "DESCHAMPS",
          s_given: "GERARD",
          s_certifiedNir: "166055623294685",
          s_nir: "166055623294685",
          s_insC: "0223181198503794416968",
        }
      ],
      i_cardStatus: 1,
      s_cardStatusText: "Carte trouvée, il s'agit d'une carte réelle",
      s_status: "OK"
    },
    {
      Patients: [
        {
          i_birthRank: 1,
          i_quality: 5,
          id: 0,
          s_birthday: "29091956",
          s_birthname: "HOULE",
          s_name: "DAVIGNON",
          s_given: "ARNAUD",
          s_certifiedNir: "156091610607565",
          s_nir: "156091610707565",
          s_insC: "0940873714439089162353",
        }
      ],
      i_cardStatus: 1,
      s_cardStatusText: "Carte trouvée, il s'agit d'une carte réelle",
      s_status: "OK"
    },
    {
      Patients: [
        {
          i_birthRank: 1,
          i_quality: 6,
          id: 0,
          s_birthday: "19101999",
          s_birthname: "POULAIN",
          s_name: "POULAIN",
          s_given: "DELPHINE",
          s_certifiedNir: "299106694532362",
          s_nir: "299106694532362",
          s_insC: "0856258941409435717878",
        }
      ],
      i_cardStatus: 1,
      s_cardStatusText: "Carte trouvée, il s'agit d'une carte réelle",
      s_status: "OK"
    },
    {
      Patients: [
        {
          i_birthRank: 2,
          i_quality: 8,
          id: 0,
          s_birthday: "04071994",
          s_birthname: "METHOT",
          s_name: "METHOT",
          s_given: "VOLETA",
          s_certifiedNir: "294071856673795",
          s_nir: "294071856673795",
          s_insC: "0115142342557989734387",
        }
      ],
      i_cardStatus: 1,
      s_cardStatusText: "Carte trouvée, il s'agit d'une carte réelle",
      s_status: "OK"
    },
    {
      Patients: [
        {
          i_birthRank: 1,
          i_quality: 9,
          id: 0,
          s_birthday: "19022004",
          s_birthname: "TALBOT",
          s_name: "TALBOT",
          s_given: "RAY",
          s_certifiedNir: "199025863604746",
          s_nir: "199025863604746",
          s_insC: "0453647152277269283539",
        }
      ],
      i_cardStatus: 1,
      s_cardStatusText: "Carte trouvée, il s'agit d'une carte réelle",
      s_status: "OK"
    },
  ];

  async lecture(slotName?: string): Promise<LectureCarteVitale> {
    return this.mockVitaleCase[Math.floor(Math.random() * this.mockVitaleCase.length)] as any;
  }

  isESConnexionIndirect() : Promise<boolean> {
    return Promise.resolve(false);
  }
}
